<template>
  <b-form action="#" @submit.prevent="reportInvalid">
    <p>
      <i>{{ $t('compliant_form.description') }}</i>
    </p>
    <b-list-group flush>
      <b-list-group-item>
        <b-form-radio-group
          :label="$t('compliant_form.label_select') + ':'"
          required
        >
          <b-form-radio
            v-model="model.compliant_reason"
            value="notcurrent"
            name="reason_option"
            >{{ $t('compliant_form.op1') }}</b-form-radio
          >
          <b-form-radio
            v-model="model.compliant_reason"
            value="contacterror"
            name="reason_option"
            >{{ $t('compliant_form.op2') }}</b-form-radio
          >
        </b-form-radio-group>

        <b-form-group
          label-cols="12"
          label-cols-sm="12"
          label-cols-lg="12"
          label-for="other"
          :label="$t('compliant_form.label_other') + ':'"
        >
          <b-input-group>
            <b-form-textarea
              :maxlength="1000"
              required
              id="other"
              v-model="model.compliant_description"
              :placeholder="$t('compliant_form.placeholder_other')"
              rows="4"
            ></b-form-textarea>
          </b-input-group>
        </b-form-group>
      </b-list-group-item>
    </b-list-group>
    <b-button variant="primary" type="submit">
      {{ $t('buttons.complain_request') }}</b-button
    >
  </b-form>
</template>
<script>
import api from '../api/api';

export default {
  props: {
    provisionLeadId: {
      type: Number,
    },
  },
  data() {
    return {
      model: {
        compliant_reason: null,
        compliant_description: null,
      },
      api_url: process.env.VUE_APP_API_URL,
      api_token: sessionStorage.getItem('api_token'),
    };
  },
  methods: {
    reportInvalid() {
      api
        .reportProvisionLeadInvalid({
          provisionLeadId: this.provisionLeadId,
          reason: this.model.compliant_reason,
          description: this.model.compliant_description,
        })
        .then(() => this.$emit('submit'))
        .catch((err) => err);
    },
  },
};
</script>
